import { flattenAndEnrichPrintingManifest } from '@onward-delivery/core';

/**
 * custom `buildGroupedManifestItemsAndCounts` to handle combined pallet and non-pallet item printing
 * Otherwise line item # index shown on label printing modal may be inaccurate.
 */
export function buildGroupedManifestItemsAndCounts(printingManifest) {
    const items = flattenAndEnrichPrintingManifest(printingManifest);
    const manifestLineIndexByPo = {};
    const pieceCountByKey = {};
    const groupedItems = (items || []).reduce((itemsObject, i) => {
        const poBucket = i.order?.po_number;
        manifestLineIndexByPo[poBucket] = (manifestLineIndexByPo[poBucket] || 0) + 1;
        const lineIdx = manifestLineIndexByPo[poBucket];

        const isPallet = i?.pallet;
        if (isPallet) {
            const key = `Pallet ${i.pallet.pallet_number}`;
            const palletArray = [...(itemsObject?.[key]?.items || [])];
            const poLabel = i.order?.po_number;
            palletArray.push({
                ...i,
                _printListKey: `Item ${poLabel}-${lineIdx}`,
            });
            itemsObject[key] = {
                items: palletArray,
                isPallet: true,
                checked: false,
                itemChecks: itemsObject?.[key]?.itemChecks || {},
                pallet_name: i.pallet?.pallet_name,
            };
            let quantityCount = pieceCountByKey[i.order_id] || 0;
            pieceCountByKey[i.item_id] = quantityCount;
            quantityCount += i?.item_piece_count || i?.quantity || 1;
            pieceCountByKey[i.order_id] = quantityCount;
        } else {
            let quantityCount = pieceCountByKey[i.order_id] || 0;
            pieceCountByKey[i.item_id] = quantityCount;
            quantityCount += i?.item_piece_count || i?.quantity || 1;
            pieceCountByKey[i.order_id] = quantityCount;

            const poLabel = i.order?.po_number;
            itemsObject[`Item ${poLabel}-${lineIdx}`] = {
                items: i,
                isPallet: false,
                checked: false,
            };
        }
        return itemsObject;
    }, {});

    return { groupedItems, countMapping: pieceCountByKey };
}
